/* eslint-disable @typescript-eslint/no-explicit-any */

export function setItemWithExpiry(key: any, value: any, ttlInMinutes: any) {
  const now = new Date();

  const item = {
    value,
    expiry: now.getTime() + ttlInMinutes * 60 * 1000, // convert minutes to ms
  };

  localStorage.setItem(key, JSON.stringify(item));
}

export function getItemWithExpiry(key: any) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    // Item has expired — remove it
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}
